<script>
import { mapActions } from "vuex";

import BaseListView from "../base/BaseListView.vue";

export default {
  extends: BaseListView,
  page: {
    title: "Sales",
  },
  data() {
    return {
      fields: [
        { key: "document_number", sortable: true, sortKey: "sale_number" },
        { key: "date", sortable: true },
        { key: "location.name", label: "Location" },
        "status",
        { key: "customer.name", label: "Customer" },
        "subject",
        "total",
        "edit",
        { key: "archive", label: "Void" },
      ],

      sales: {},
      query_params: {
        page: 1,
        page_size: 25,
        ordering: '-date, -sale_number',
        search: null,
      },
    };
  },
  methods: {
    ...mapActions("sales", ["fetchSales", "archiveSale"]),
    ...mapActions("application", ["setIsTableLoading"]),
    
    create() {
      this.$router.push({
        name: "Edit Sale",
      });
    },

    edit(id) {
      this.$router.push({
        name: "Edit Sale",
        params: {
          id: id,
        },
      });
    },

    async query() {
      await this.setIsTableLoading(true);
      await this.fetchSales({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.sales = res.data;
      }).catch((error) => {
      }).finally(() => {
        this.setIsTableLoading(false);
      });
    },
  },
  mounted() {
    //this.query();
  },
  watch: {
    'query_params.location': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$set(this.query_params, 'register', null);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      modelName="Sales"
      @create="create"
      @showfilters="show_filters = $event"
      v-model="query_params.search"
    />

    <div class="mx-1 mb-2" ref="filters" :hidden="!show_filters">
      <div class="row mb-3">
        <div class="col-3">
          <base-input type="multiselect"  id="archived" label="Archived" v-model="query_params.archived" :options="archived_options" />
        </div>
        <div class="col-3">
          <base-input label="Start Date" type="date" v-model="query_params.date_start" />
        </div>
        <div class="col-3">
          <base-input label="End Date" type="date" v-model="query_params.date_end" />
        </div>
        <div class="col-3">
          <base-input
            label="Delivery Date"
            type="date"
            v-model="query_params.delivery_date"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3">
          <base-customer-selector v-model="query_params.customer" />
        </div>
        <div class="col-3">
          <base-location-selector v-model="query_params.location" />
        </div>
        <div class="col-3">
          <base-sale-selector label_name="Parent" v-model="query_params.parent" />
        </div>
        <div class="col-3">
          <base-input
            label="Payment Deadline"
            type="date"
            v-model="query_params.payment_deadline"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3">
          <base-price_list-selector v-model="query_params.price_list" />
        </div>
        <div class="col-3">
          <base-register-selector v-model="query_params.register" :disabled="!query_params.location" :location="query_params.location" />
        </div>
        <div class="col-3">
          <base-input type="multiselect"  id="status_filter" label="Status" v-model="query_params.status" :options="['Draft', 'Confirmed']" />
        </div>
        <div class="col-3">
          <base-user-selector v-model="query_params.sales_person" />
        </div>
      </div>
      <el-divider class="my-4"></el-divider>
    </div>

    <base-card>
      <base-table
        ref="table"
        :data_="sales"
        :fields="fields"
        @archive="archive"
        @edit="edit"
        @page_change="query_params.page = $event"
        @page_size_change="query_params.page_size = $event"
        @ordering_change="query_params.ordering = $event"
      />
    </base-card>
  </div>
</template>